﻿import { YouTubePlayer } from "youtube-player/dist/types";
import VimeoPlayer from "@vimeo/player";
import PlayerStates from "youtube-player/dist/constants/PlayerStates";
import { prefersReducedMotion } from "../Utilities/userPreferences";
import { getPlayer, isVimeoPlayer, isYouTubePlayer } from "../Utilities/video";

const playYouTubeVideo = async (player: YouTubePlayer) => {
  const state = await player.getPlayerState();

  if (state !== PlayerStates.PLAYING) {
    await player.playVideo();
  }
};

const playVimeoVideo = async (player: VimeoPlayer) => {
  if (await player.getPaused()) {
    await player.play();
  }
};

export const playVideo = async (player: VimeoPlayer | YouTubePlayer) => {
  if (isYouTubePlayer(player)) {
    await playYouTubeVideo(player);
  }

  if (isVimeoPlayer(player)) {
    await playVimeoVideo(player);
  }
};

export const pauseVideo = async (player: VimeoPlayer | YouTubePlayer) => {
  if (isYouTubePlayer(player)) {
    if ((await player.getPlayerState()) == PlayerStates.PAUSED) {
      console.info("The YouTube video is already paused");
      return;
    }

    await player.pauseVideo();
    console.info("The YouTube video paused");
  }

  if (isVimeoPlayer(player)) {
    if (await player.getPaused()) {
      console.info("The Vimeo video is already paused");
      return;
    }

    await player.pause();
    console.info("The Vimeo video paused");
  }
};

const hidePreviewButton = (videoPreviewButton: HTMLElement) => {
  videoPreviewButton.inert = true;
};

document.querySelectorAll<HTMLElement>("[data-video]").forEach(async videoElement => {
  const videoPreviewButton = videoElement.querySelector(
    "[data-video-preview-button]"
  ) as HTMLButtonElement;

  if (!videoPreviewButton) {
    console.info("A video without a preview button - skipping");
    return;
  }

  const videoIframe = videoElement.querySelector("iframe");
  if (!videoIframe) {
    console.error("A video iframe missing!");
    return;
  }

  const player = getPlayer(videoIframe);

  if (!player) {
    console.error("Couldn't get a video player");
    return;
  }

  const autoplay = videoElement.dataset.autoplay === "true";

  // Button on click handler
  videoPreviewButton.onclick = async () => {
    hidePreviewButton(videoPreviewButton);
    await playVideo(player);
  };

  // Autoplay when scrolled into view
  if (autoplay && !prefersReducedMotion()) {
    const scrolledIntoViewHandler = async (entries: IntersectionObserverEntry[]) => {
      if (entries.some(entry => entry.isIntersecting)) {
        hidePreviewButton(videoPreviewButton);
        await playVideo(player);
      }
    };

    const intersectionObserver = new IntersectionObserver(scrolledIntoViewHandler, {
      threshold: 0
    });

    intersectionObserver.observe(videoIframe);
  }
});
